import moment from "moment";
import React, { useMemo, useState } from "react";
import TodayLineGraph from "./TodayLineGraph";


function LineGraph({ timestamps, data, unit, id, type }) {


  const [clickedElement, setClickedElement] = useState({
    date: " ",
    time: "",
    value: ""
  });

  const datas = useMemo(() => {
    return {
      labels: timestamps,
      datasets: [
        {
          label: "",
          data: data,
          // borderColor: "#339989",
          borderColor: "#0066cc",
        },
      ],
    }
  }, [])

  return <>
    {/* <Label clickedElement={clickedElement}
      unit={unit}
      type={type}
    /> */}
    <div style={{
      width: "100%",
      height: "300px"
    }}>
      <TodayLineGraph
        setClickedElement={setClickedElement}
        id={id}
        unit={unit}
        type={type}
        timestamps={timestamps}
        datas={datas} />
    </div>

  </>

}

const Label = ({ clickedElement, unit, type }) => {
  return (
    <h5>Date: {clickedElement.date}
      <br />
      Time: {clickedElement.time}
      <br />

      {type}: {clickedElement.value} {unit === 'percent' ? "%" : unit === 'celsius' ? '°C' : unit}
    </h5>

  )
}

export default LineGraph;




// import moment from "moment";
// import React, { useMemo, useState } from "react";
// import TodayLineGraph from "./TodayLineGraph";

// function LineGraph({ timestamps, data, unit, id, type }) {

//   // -----------------------
//   // FORMAT HOUR LABELS HERE
//   // -----------------------
// const formatHourRange = (hour) => {
//   const start = hour.toString().padStart(2, "0");
//   const end = ((hour + 1) % 24).toString().padStart(2, "0");
//   return `${start}-${end}`;
// };

// // For custom X-axis tick
// const CustomTick = ({ x, y, payload }) => {
//   const hour = payload.value;   // 0–23
//   const label = formatHourRange(hour);

//   const isAM = hour === 0;   // show AM under hour 0
//   const isPM = hour === 12;  // show PM under hour 12

//   return (
//     <g transform={`translate(${x},${y})`}>
//       <text dy={16} textAnchor="middle" fill="#555">
//         {label}
//       </text>

//       {isAM && (
//         <text dy={32} textAnchor="middle" fill="#555" fontWeight="bold">
//           AM
//         </text>
//       )}

//       {isPM && (
//         <text dy={32} textAnchor="middle" fill="#555" fontWeight="bold">
//           PM
//         </text>
//       )}
//     </g>
//   );
// };


//   const [clickedElement, setClickedElement] = useState({
//     date: " ",
//     time: "",
//     value: "",
//   });

//   const datas = useMemo(() => {
//     return {
//       labels: timestamps,
//       datasets: [
//         {
//           label: "",
//           data: data,
//           borderColor: "#0066cc",
//         },
//       ],
//     };
//   }, [timestamps, data]);

//   return (
//     <>
//       <div
//         style={{
//           width: "100%",
//           height: "300px",
//         }}
//       >
//         <TodayLineGraph
//   setClickedElement={setClickedElement}
//   id={id}
//   unit={unit}
//   type={type}
//   timestamps={timestamps}
//   datas={datas}
//   formatHourRange={formatHourRange}
//   CustomTick={CustomTick}   // ADD THIS
// />

//       </div>
//     </>
//   );
// }

// export default LineGraph;
